<template>
  <div
    class="content"
    id="msVoucher"
  >
    <div class="title">
      <h3>{{$t('ms.siderText')[1].text}}</h3>
      <div class="title-underline"></div>
    </div>
    <div
      class="card"
      v-for="item in list"
      :key="item.id"
    >
      <img
        class="card-img"
        :src="item.logoUrl"
        alt=""
      >
      <div class="card-right">
        <div class="card-right-top-row">
          <div class="card-info">
            <h3 class="card-info-title">{{item.campaignName}}</h3>
            <span class="card-info-text">
              {{$t('ms.voucherText.infoText')}}
            </span>
            <span class="card-info-endTime">
              {{$t('ms.voucherText.infoEndTime')}}
              <span class="time">{{item.endDate | FormData}}</span></span>
          </div>
          <div class="d-flex justify-content-between flex-fill flex-wrap">
            <div class="card-id">
              {{$t('ms.voucherText.orderID')}}
              {{item.orderId}}
            </div>
            <div class="card-price">
              <span class="newPrice">${{item.newPrice}}</span>
              <span class="oldPrice">${{item.oldPrice}}</span>
            </div>
          </div>
        </div>
        <div class="card-right-bottom-row">
          <div class="card-payMethod-row">
            <button class="appleWallet">
              <img
                src="@/assets/images/wallet.svg"
                alt=""
              >
              {{$t('ms.voucherText.appleWallet')}}
            </button>
            <button class="pay">
              <img
                src="@/assets/images/google.svg"
                alt=""
              >
              {{$t('ms.voucherText.pay')}}<span class="verticalLine">|</span>{{$t('ms.voucherText.savePhone')}}
            </button>
          </div>
          <button class="card-searchBtn">{{$t('ms.voucherText.buttonText')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [
        {
          "campaignId": "1",
          "campaignName": "MUJI GIFT$100 禮品卡",
          "oldPrice": "100",
          "newPrice": "50",
          "orderId": "H201029069341",
          "endDate": "2021-02-28",
          "logoUrl": require('@/assets/images/thumbnail.png'),
        },
        {
          "campaignId": "1",
          "campaignName": "MUJI GIF",
          "oldPrice": "100",
          "newPrice": "50",
          "orderId": "H201029069341",
          "endDate": "2021-02-28",
          "logoUrl": require('@/assets/images/thumbnail.png'),
        },
        {
          "campaignId": "1",
          "campaignName": "MUJI GIFT$100 禮品卡MUJI GIFT$100 禮品卡MUJI GIFT$100 禮品卡",
          "oldPrice": "100",
          "newPrice": "50",
          "orderId": "H201029069341",
          "endDate": "2021-02-28",
          "logoUrl": require('@/assets/images/thumbnail.png'),
        }
      ]
    }
  },
  filters: {
    FormData (value) {
      const dateArr = value.split('-')
      if (localStorage.getItem('lang') === 'zh') {
        return `${dateArr[0]}年${dateArr[1]}月${dateArr[2]}日`
      } else {
        return dateArr.join('/')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.nowrap {
  white-space: nowrap;
}
.content {
  padding-bottom: 114px;
  .title {
    margin-bottom: 26px;
    position: relative;
    text-align: left;
    .title-underline {
      content: "";
      position: relative;
      width: 32px;
      height: 5px;
      background-color: #ffbf00;
      border-radius: 3px;
      &::after {
        position: absolute;
        content: "";
        left: 37px;
        width: 5px;
        height: 5px;
        background-color: #ffbf00;
        border-radius: 50%;
      }
    }
  }
}

.card {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  margin: 25px 0;
  padding: 28px 14px 20px;
  border: none;
  border-radius: 5px;
  > .card-img {
    margin: 0 14px;
    width: 112px;
    height: 112px;
    border-radius: 50%;
  }
  .card-right {
    margin: 0 14px;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .card-right-top-row {
      display: flex;
      flex-wrap: wrap;
      text-align: left;
      justify-content: space-between;
      .card-info {
        flex: 4;
        margin-right: 20px;
        .card-info-title {
          font-family: Noto Sans CJK TC;
          font-weight: bold;
          font-size: 24px;
          line-height: 36px;
          color: #0f96bb;
        }
        .card-info-text,
        .card-info-endTime {
          display: block;
          font-family: Roboto;
          font-size: 14px;
          line-height: 24px;
          color: #b3b3b3;
        }
        .card-info-endTime .time {
          white-space: nowrap;
        }
      }
      .card-id {
        font-family: Roboto;
        font-size: 14px;
        line-height: 24px;
        color: #666666;
      }
      .card-price {
        text-align: center;
        .newPrice {
          display: block;
          font-family: Roboto;
          font-weight: bold;
          font-size: 36px;
          line-height: 42px;
          color: #545454;
        }
        .oldPrice {
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 19px;
          text-decoration-line: line-through;
          color: #545454;
        }
      }
    }
    .card-right-bottom-row {
      margin-top: 20px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      button {
        border: none;
        outline: none;
        white-space: nowrap;
        max-height: 30px;
        &:hover {
          opacity: 0.9;
        }
        &:active {
          opacity: 0.8;
        }
      }
      .card-payMethod-row {
        margin-bottom: 10px;
        display: flex;
        flex-wrap: wrap;
        .appleWallet,
        .pay {
          margin-bottom: 10px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          margin-right: 15px;
          width: 190px;
          height: 30px;
          font-size: 14px;
          border-radius: 3px;
        }
        .appleWallet {
          color: #fff;
          background-color: #000;
          > img {
            height: 100%;
          }
        }
        .pay {
          border: 1px solid #cdcdcd;
          background-color: #fefefe;
          > img {
            height: 60%;
          }
          > .verticalLine {
            margin: 0 8px;
            color: #ddd;
          }
        }
      }
      .card-searchBtn {
        position: relative;
        padding: 0 15px;
        font-family: Noto Sans TC;
        font-weight: 300;
        font-size: 14px;
        color: #0f96bb;
        border-radius: 3px;
        border: 1px solid #0f96bb;
        background-color: transparent;
        z-index: 1;
        &::after {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 0px;
          height: 100%;
          background-color: #0f96bb;
          z-index: -1;
          transition: all 0.2s;
        }
        &:hover {
          color: #fff;
          &::after {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>